/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% off 220: you save 33, final price 187.`)
};

const es_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de descuento sobre 220: ahorras 33, precio final 187.`)
};

const de_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% Rabatt auf 220: du sparst 33, Endpreis 187.`)
};

const nl_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% korting op 220: je bespaart 33, eindprijs 187.`)
};

const fr_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 % de réduction sur 220 : vous économisez 33, prix final 187.`)
};

const it_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% di sconto su 220: risparmi 33, prezzo finale 187.`)
};

const pt_br2_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de desconto em 220: você economiza 33, preço final 187.`)
};

const pt_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de desconto em 220: poupa 33, preço final 187.`)
};

const ja_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`220の15%オフ: 節約額33、最終価格187。`)
};

const zh_pct_discount_ex4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`220 打 15% 折扣：节省 33，最终价格 187。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_ex4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_ex4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_ex4", locale)
	if (locale === "en") return en_pct_discount_ex4(inputs)
	if (locale === "es") return es_pct_discount_ex4(inputs)
	if (locale === "de") return de_pct_discount_ex4(inputs)
	if (locale === "nl") return nl_pct_discount_ex4(inputs)
	if (locale === "fr") return fr_pct_discount_ex4(inputs)
	if (locale === "it") return it_pct_discount_ex4(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_ex4(inputs)
	if (locale === "pt") return pt_pct_discount_ex4(inputs)
	if (locale === "ja") return ja_pct_discount_ex4(inputs)
	return zh_pct_discount_ex4(inputs)
};